const name = 'video-call';
const path = '/video-chamada';

export default [
  // routes
  {
    name: `${name}`,
    path: `${path}`,
    component: () => import('@/views/VideoCall.vue'),
  },
];
